const courseMenus = [
  {
    id: "aiCourses",
    label: "AI courses",
    position: { left: "0" },
    sections: [
      {
        links: [
          {
            label: "Compare AI courses",
            to: "/ai-agents/",
          },
        ],
      },
      {
        label: "Bootcamps",
        links: [
          {
            label: "AI Agent & Automation Bootcamp",
            to: "/ai-business-automation-architect/",
          },
          {
            label: "Vibe Coding Bootcamp",
            to: "/vibe-coding-bootcamp-with-claude/",
          },
          // {
          //   label: "AI Agent & Automation Bootcamp",
          //   to: "/ai-agent-engineer-bootcamp/",
          // },
          {
            label: "Deep Learning and AI Engineering Bootcamp",
            to: "/machine-learning-and-ai-engineering-bootcamp/",
          },
        ],
      },
      {
        label: "Short courses",
        links: [
          {
            label: "n8n Course",
            to: "/n8n-course/",
          },
          {
            label: "AI Agents Builder",
            to: "/ai-agents-builder-course/",
          },
          {
            label: "Work Automation with AI Agents",
            to: "/work-automation-with-ai-agents/",
          },
          {
            label: "AI Act Compliance Training",
            to: "/ai-compliance-training/",
          },
        ],
      },
    ],
  },
  {
    id: "designCourses",
    label: "Design courses",
    position: { left: "-2em" },
    sections: [
      {
        label: "Bootcamps",
        links: [
          {
            label: "UX/UI Design with AI full-time Bootcamp",
            to: "/ux-design-bootcamp-in-barcelona-code-school/",
          },
          {
            label: "UX/UI Design with AI part-time Bootcamp",
            to: "/ux-design-online-mentored-bootcamp/",
          },
        ],
      },
      {
        label: "Short courses",
        links: [
          {
            label: "Figma Crash Course",
            to: "/design-and-prototype-in-figma/",
          },
          {
            label: "Branding in UX/UI Design",
            to: "/branding-in-ux-ui-design-workshop/",
          },
        ],
      },
    ],
  },
  {
    id: "codingCourses",
    label: "Coding courses",
    position: { left: "-4em" },
    sections: [
      {
        label: "Bootcamps",
        links: [
          {
            label: "Web / Mobile Development with AI full-time Bootcamp",
            to: "/barcelona-code-school/javascript-full-stack-bootcamp/",
          },
          {
            label: "Web / Mobile Development with AI part-time Bootcamp",
            to: "/barcelona-code-school/javascript-full-stack-online-bootcamp/",
          },
        ],
      },
      {
        label: "Short courses",
        links: [
          // {
          //   label: "Young Coders Summer Camp",
          //   to: "/bcs-young-coders-summer-camp-2026/",
          // },
          {
            label: "Responsive Web Design / CSS3",
            to: "/responsive-web-design-with-css3/",
          },
          {
            label: "Programming with JavaScript",
            to: "/programming-with-javascript/",
          },
          {
            label: "React.js Crash Course",
            to: "/reactjs-crash-course/",
          },
          {
            label: "Back-End Development with Express",
            to: "/backend-development-with-node-express-mongodb/",
          },
        ],
      },
      {
        label: "Self-paced courses on Udemy",
        links: [
          {
            label: "HTML & CSS for Total Newbies",
            href: "https://www.udemy.com/course/html-and-css-for-the-total-newbies/?referralCode=3463E1667BB1FD9D016C",
          },
          {
            label: "Programming with Python",
            href: "https://www.udemy.com/course/programming-with-python-bcs/?referralCode=9B251D06407ACC8D5DBC",
          },
          {
            label: "Nodemailer, Gmail and OAuth2",
            href: "https://www.udemy.com/course/sending-emails-with-nodemailer-gmail-and-oauth2/?referralCode=53A07520999CD0870D6B",
          },
          {
            label: "Back-End Development with Node.js, Express and MongoDB",
            href: "https://www.udemy.com/course/backend-development-with-nodejs-expressjs-mongodb/?referralCode=53A07520999CD0870D6B",
          },
        ],
      },
    ],
  },
  {
    id: "gameDevCourses",
    label: "GameDev courses",
    position: { right: "0" },
    sections: [
      {
        label: "Bootcamps",
        links: [
          {
            label: "Game Development full-time Bootcamp",
            to: "/game-development-bootcamp/",
          },
          {
            label: "Game Development part-time Bootcamp",
            to: "/game-development-online-bootcamp/",
          },
        ],
      },
    ],
  },
];

export default courseMenus;
